import { Row, Col, Card } from 'react-bootstrap';
import { Bars } from 'react-loader-spinner';

import { useOrders } from '../../features/orders/useOrders.js';

import OrderFulfillmentChart from '../../components/charts/sales-management-charts/OrderFulfillmentChart.js';
import OrdersAllocationStatusChart from '../../components/charts/sales-management-charts/OrdersAllocationStatusChart.js';
import OrdersMonitorTable from './OrdersMonitorTable.js';
import OrderMonitorKpis from '../../components/sales-management/OrderMonitorKpis.js';
import ProductionJobsTable from '../../components/tables/ProductionJobsTable.js';

const OrderMonitor = () => {
  const {
    data: orders = [],
    isLoading,
    isFetching,
    error,
    refetch
  } = useOrders();

  if (isLoading) {
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={'#3874ff'}
        ariaLabel="three-dots-loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );
  }

  return (
    <div className="pb-9">
      <div className="d-flex align-items-center gap-3 mb-4">
        <h2 className="mb-0">Order Monitor</h2>
        {isFetching && <span className="text-muted fs-10">(refreshing…)</span>}
        {error && <span className="text-danger fs-10">{String(error)}</span>}
      </div>

      {/* KPI STRIP */}
      <OrderMonitorKpis orders={orders} />

      {/* TOP CHARTS */}
      <Row className="gy-2 mt-1">
        <Col xl={8} xxl={8}>
          <Card className="h-100">
            <Card.Body>
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Order fulfillment &amp; deadlines</h4>
                <span className="text-muted fs-10">
                  ● overdue · ⚠ due ≤ 7 days
                </span>
              </div>
              <OrderFulfillmentChart
                orders={orders}
                style={{ height: 460, width: '100%' }}
              />
            </Card.Body>
          </Card>
        </Col>

        <Col xl={4} xxl={4}>
          <Card className="h-100">
            <Card.Body>
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Allocation / Production status</h4>
              </div>
              <OrdersAllocationStatusChart
                orders={orders}
                style={{ height: 320, width: '100%' }}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* TABLE MONITOR */}
      <Row className="gy-2 mt-4">
        <Col>
          <OrdersMonitorTable orders={orders} onRefresh={refetch} />
        </Col>
      </Row>

      {/* PRODUCTION JOBS — destination (stock/client) + phase + reserve */}
      <Row className="gy-2 mt-4">
        <Col>
          <Card>
            <Card.Body>
              <h3 className="mb-1">Production Jobs</h3>
              <p className="text-700 mb-3">
                All products launched in production — stock vs client, current
                phase, and stock reservation
              </p>
              <ProductionJobsTable />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }
};

export default OrderMonitor;
